<script>
    export let user, params;
</script>
<main class="container py-5 text-center">
    <h1 class="text-danger text-center">Wooo! Wo! Wowo!</h1>
    <p class="text-dark">
        We can't find the page you are looking for.
    </p>
    <kbd class="text-small text-muted">ERROR: 404</kbd>
</main>
<div class="row">
    <div class="col text-center">
        <a href="/">Back</a>
    </div>
</div>
